"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Footnote = _interopRequireDefault(require("../../../text/Footnote"));

var _Typography = _interopRequireDefault(require("../../../text/Typography"));

var _useCurrency2 = _interopRequireDefault(require("../../../../hooks/useCurrency"));

var _Currency = require("../../../../utils/Currency");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Price(_ref) {
  var className = _ref.className,
      label = _ref.label,
      price = _ref.price,
      footnoteName = _ref.footnoteName,
      hasCents = _ref.hasCents,
      fontSize = _ref.fontSize,
      props = _objectWithoutProperties(_ref, ["className", "label", "price", "footnoteName", "hasCents", "fontSize"]);

  if (!price) {
    return null;
  }

  var _useCurrency = (0, _useCurrency2["default"])(),
      code = _useCurrency.code,
      isNativeCurrency = _useCurrency.isNativeCurrency;

  var formattedPrice = (0, _Currency.getFormattedPrice)(price, hasCents);
  var size = typeof fontSize === 'undefined' ? 'inherit' : fontSize;
  return _react["default"].createElement(_Typography["default"], _extends({
    className: className,
    nativeTag: "span",
    fontSize: size,
    wrap: false
  }, props), label, " ", formattedPrice, !isNativeCurrency && " ".concat(code), _react["default"].createElement(_Footnote["default"], {
    name: footnoteName
  }));
}

Price.displayName = 'Price';
Price.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].string,
  price: _propTypes["default"].number,
  footnoteName: _propTypes["default"].string,
  hasCents: _propTypes["default"].bool,
  fontSize: _propTypes["default"].number
};
Price.defaultProps = {
  className: '',
  hasCents: false
};

var _default = (0, _react.memo)(Price);

exports["default"] = _default;